module.exports = __webpack_public_path__ + "static/media/search.b8642b99.svg";